module.exports = __webpack_public_path__ + "img/image-thumb-19.c7311b11.webp";